import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import defined from '~app/core/defined';

import ContinuousTimeline from './ContinuousTimeline';
import DiscreteTimeline from './DiscreteTimeline';

class Timeline extends Component {

  static propTypes = {
    activeLayerName: PropTypes.string,
    maps: PropTypes.array,
  }

  renderTimeline() {
    if (this.props.activeLayerName === "Anthromes") {
      return <DiscreteTimeline />;
    }
    else {
      return <ContinuousTimeline />;
    }
  }

  render() {
    if (defined(this.props.activeLayerName) &&
        this.props.maps.length > 1) {

      return (
        <div className="Timeline">
          { this.renderTimeline() }
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = (state) => ({
  activeLayerName: state.layer.layers[state.layer.activeLayerIndex].name,
  maps: state.layer.layers[state.layer.activeLayerIndex].maps,
});

export { Timeline };
export default connect(mapStateToProps)(Timeline);



// WEBPACK FOOTER //
// ./src/components/Timeline.js